import { debug as d } from "debug";

const debug = d("cs.RenderWaiter");

// Provides a simple interface for child components to notify their parents
// when they have finished rendering
export default class RenderWaiter {
  waitList: any[];

  waitFor(me: unknown): void {
    debug("waitFor", me);
    if (this.waitList.indexOf(me) === -1) {
      this.waitList.push(me);
    }
  }

  notifyReady(me: unknown): void {
    debug("notifyReady", me);
    const index = this.waitList.indexOf(me);
    if (index !== -1) {
      this.waitList.splice(index, 1);
      debug(`Now waiting for ${this.waitList.length}`, this.waitList);
    }
  }

  constructor(waitList: any[]) {
    this.waitList = waitList;
  }
}
